import React from 'react';
import { WithSocialLogin } from './with-social-login';
/**
 * @see {@link WithSocialLogin}
 * @component
 * @category Login
 */

export function WithGoogleLogin(_ref) {
  var clientId = _ref.clientId,
      children = _ref.children,
      scope = _ref.scope,
      emailMandatory = _ref.emailMandatory,
      redirectUrl = _ref.redirectUrl,
      sso = _ref.sso,
      isBridgekeeperLogin = _ref.isBridgekeeperLogin;
  return /*#__PURE__*/React.createElement(WithSocialLogin, {
    provider: 'google',
    initialize: function initialize() {
      return loadGoogleSDK(clientId, scope);
    },
    socialLogin: function socialLogin() {
      return loginWithGoogle({
        emailMandatory: emailMandatory
      });
    },
    children: children,
    redirectUrl: redirectUrl,
    sso: sso,
    isBridgekeeperLogin: isBridgekeeperLogin
  });
}

var onScriptLoaded = function onScriptLoaded(clientId, scope) {
  global.gapi.load('client:auth2', function () {
    return global.gapi.client.init({
      clientId: clientId,
      scope: scope
    });
  });
};

var loginWithGoogle = function loginWithGoogle() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      emailMandatory = _ref2.emailMandatory;

  if (!global.gapi || !global.gapi.client) {
    return Promise.reject("NOT_LOADED");
  }

  var GoogleAuth = global.gapi.auth2.getAuthInstance();

  if (!GoogleAuth) {
    return Promise.reject("NOT_LOADED");
  }

  return GoogleAuth.signIn().then(function (response) {
    return emailMandatory && !response.getBasicProfile().getEmail() ? Promise.reject('NO_EMAIL') : {
      'access-token': response.getAuthResponse().access_token
    };
  })["catch"](function () {
    return Promise.reject('NOT_GRANTED');
  });
};

var loadGoogleSDK = function loadGoogleSDK(clientId, scope) {
  if (global.gapi) {
    return;
  }

  var script = document.createElement('script');
  script.src = 'https://apis.google.com/js/api.js';
  script.async = true;
  script.defer = true;

  script.onload = function () {
    return onScriptLoaded(clientId, scope);
  };

  document.getElementsByTagName('body')[0].appendChild(script);
};